import { render, staticRenderFns } from "./birthday-pop.vue?vue&type=template&id=ffac469a&scoped=true&"
import script from "./birthday-pop.vue?vue&type=script&lang=js&"
export * from "./birthday-pop.vue?vue&type=script&lang=js&"
import style0 from "./birthday-pop.vue?vue&type=style&index=0&id=ffac469a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffac469a",
  null
  
)

export default component.exports